module.exports = __webpack_public_path__ + "static/media/AB_angel_white_desktop_flipped.76a359d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_angel_white_desktop_flipped.png
// module id = 593
// module chunks = 0